import('../../../../../../styles/pages/charts/index/components/arrow.css')

export default function Arrow(options){
    let direction = options.direction || 'right'
    let title = options.title

    let container_element,arrow_element;

    this.generate = () =>{
        //gerar container
        generateContainer()
        //gerar arrow
        generateArrow()

        //posicionar arrow na tela
        setPosition()
        // //adicionar eventos
        eventsHandler()

        tippy(container_element, {
            content: "Expandir painel " + title,
            placement: direction
        });
        
    }

    this.update = (count) =>{
        let klass = (count >= 0) ? 'mr-1' : ''
        arrow_element.innerHTML = '<span class="'+klass+'">'+count+'</span><i class="'+getIcon()+'"></i>'
    }

    function generateContainer(){
        let element = document.createElement('div')
        element.classList.add("arrow-container")
        element.classList.add("arrow-container-"+direction)
        container_element = element
    }

    function generateArrow(){
        let element = document.createElement('div')
        element.classList.add("arrow-wrapper")
        element.innerHTML = '<i class="'+getIcon()+'"></i>'
        arrow_element = element
        container_element.appendChild(arrow_element)
    }

    function setPosition(){
        $('section').append(container_element)
    }

    function getIcon(){
        if(direction == 'right'){
            return 'fas fa-chevron-left'
        } else {
            return 'fas fa-chevron-right'
        }
    }

    function eventsHandler(){
        $(container_element).on('click', ()=>{
            $(document).trigger('chevron-arrow:click', {direction:direction})
        })
    }

}